import { db } from '$db/local/db';
import { getActiveUserId } from '$core/identity/active-user';

export async function exportToFile(): Promise<void> {
  const userId = getActiveUserId();
  
  const bundle = {
    version: 5,
    exportedAt: new Date().toISOString(),
    nodes: await db.nodes.where('userId').equals(userId).toArray(),
    nodeTemplates: await db.nodeTemplates.where('userId').equals(userId).toArray(),
    macroSessions: await db.macroSessions.where('userId').equals(userId).toArray(),
    problemAttempts: await db.problemAttempts.where('userId').equals(userId).toArray(),
    recallItems: await db.recallItems.where('userId').equals(userId).toArray(),
    reviewEvents: await db.reviewEvents.where('userId').equals(userId).toArray(),
    memoryWeights: await db.memoryWeights.where('userId').equals(userId).toArray(),
    conjectures: await db.conjectures.where('userId').equals(userId).toArray(),
    sleepRecords: await db.sleepRecords.where('userId').equals(userId).toArray(),
    studyGoals: await db.studyGoals.where('userId').equals(userId).toArray(),
  };

  const blob = new Blob([JSON.stringify(bundle, null, 2)], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `studyquantifier-backup-${Date.now()}.json`;
  a.click();
  URL.revokeObjectURL(url);
}